import { Link } from 'react-router-dom'
import { contentFor } from '../transport/content'
import type { Locale } from '../transport/types'

export function Logo({ homePath, locale, className = '' }: { homePath: string; locale: Locale; className?: string }) {
  const content = contentFor(locale)
  return (
    <Link className={`brand-logo ${className}`} to={homePath} aria-label={locale === 'ar' ? 'الصفحة الرئيسية' : 'Home'}>
      <span className="brand-wordmark"><strong>{content.brand}</strong><small>{content.brandSubtitle}</small></span>
    </Link>
  )
}
